import {Bank} from "./bank.model";
import {ChartOfAccounts} from "../../chart-of-accounts/chart-of-accounts.model";
import { Party } from "src/app/party/party.model";


/**
 * Represents a specific bank account, which can belong to the company or another party.
 */
export class BankAccount {
    id: number;
    accountName: string; // A user-friendly name, e.g., "Main Operating Account"
    accountNumber: string;
    iban: string;
    currencyCode: string; // e.g., 'SAR', 'USD'

    // Optional nested Bank object for holding complete bank details
    bank?: Bank;

    // Identifies who owns this bank account
    party: Party;

    account: ChartOfAccounts;
    owningCompanyId: number;

    reconciliationEnabled?: boolean;
    reconciliationVarianceTolerance?: number;
    defaultSuspenseAccountId?: number;
    bankFeesAccountId?: number;
    interestIncomeAccountId?: number;
    interestExpenseAccountId?: number;
    lastReconciledDate?: string;
    verificationStatus?: string;
    verifiedBy?: number;
    verifiedAt?: string;
    verificationReason?: string;
}
